import type { MouseEventHandler } from "react";
import { useCallback, useEffect, useState } from "react";

export interface IUseActiveElement {
    isElementActive: boolean;
    onActivatableElementMouseDown: MouseEventHandler;
}

/**
 * @description
 * Хук, инкапсулирующий в себе работу с состоянием элемента, который может быть активным
 */
export const useActivatableElement = (): IUseActiveElement => {
    const [isElementActive, setIsElementActive] = useState<boolean>(false);

    /**
     * Защищаемся при клике за пределами кнопки.
     * Такое может произойти, если мы нажали на кнопку и, удерживая, сместили курсор за её пределы.
     */
    useEffect(() => {
        if (isElementActive) {
            const nativeMouseUpHandler = () => setIsElementActive(false);

            document.addEventListener("mouseup", nativeMouseUpHandler);

            return () =>
                document.removeEventListener("mouseup", nativeMouseUpHandler);
        }
    }, [isElementActive]);

    const onActivatableElementMouseDown = useCallback(
        () => setIsElementActive(true),
        [],
    );

    return { isElementActive, onActivatableElementMouseDown };
};
